import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCursor3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconCursor3"><Path d="M5.1518 2.88442C3.73068 2.32834 2.32834 3.73069 2.88442 5.1518L8.24434 18.8494C8.70422 20.0246 10.2191 20.3415 11.1114 19.4491L12.4999 18.0606L16.1161 21.6767C16.6042 22.1649 17.3957 22.1649 17.8838 21.6767L21.6767 17.8838C22.1649 17.3957 22.1649 16.6042 21.6767 16.1161L18.0606 12.4999L19.4491 11.1115C20.3415 10.2191 20.0246 8.70421 18.8494 8.24434L5.1518 2.88442Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCursor3;
